import { PROJECT_PATH, WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';
const _axios = HttpService.getAxiosClient();

export const getUserData = async (userId) => {
  try {
    const response = await _axios.get(`${PROJECT_PATH}/users/${userId}`);
    return ErrorSwitchCase(response);
  } catch (error) {
    console.log(error);
    return ErrorSwitchCase(error.response.data);
  }
};

export const getUsers = async (name, pageSize, pageNo, status = '') => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/?${'name=' + name}${
        pageSize ? '&pageSize=' + pageSize : ''
      }${pageNo >= 0 ? '&pageNumber=' + pageNo : ''}${status != '' ? '&status=' + status : ''}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserProjects = async (
  userId,
  projectName = '',
  pageSize = '',
  pageNumber = '',
  projectStatus = '',
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${userId}/projects?projectName=${projectName}${
        pageNumber >= 0 ? '&pageNumber=' + pageNumber : ''
      }${pageSize ? '&pageSize=' + pageSize : ''}${
        projectStatus ? '&projectStatus=' + projectStatus : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getUserTasks = async (
  userId,
  filters,
  isAppraisal,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${userId}/tasks?${
        filters.startDate ? 'startDate=' + filters.startDate + '&' : ''
      }${filters.endDate ? 'endDate=' + filters.endDate + '&' : ''}${
        filters.projectId ? 'projectId=' + filters.projectId + '&' : ''
      }${filters.taskTitle ? 'titleName=' + filters.taskTitle + '&' : ''}${
        filters.taskId ? 'taskId=' + filters.taskId + '&' : ''
      }${filters.taskType ? 'taskType=' + filters.taskType + '&' : ''}${
        isAppraisal ? 'isAppraisal=' + isAppraisal + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const downloadUserTasks = async (
  userId,
  startDate,
  endDate,
  filters,
  isAppraisal,
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${userId}/tasks/download?${
        startDate ? 'startDate=' + startDate + '&' : ''
      }${endDate ? 'endDate=' + endDate + '&' : ''}${
        filters.projectId ? 'projectId=' + filters.projectId + '&' : ''
      }${filters.taskType ? 'taskType=' + filters.taskType + '&' : ''}${
        isAppraisal ? 'isAppraisal=' + isAppraisal + '&' : ''
      }`,
      { responseType: 'blob' },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserManagers = async (userId) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${userId}/managers`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

/**
 * Resolves the employee's fallback Reporting/Senior Manager for leave/WFH
 * routing, used when the employee is the sole manager on their project and
 * getUserManagers returns no peer manager to approve.
 */
export const getReportingManagerForLeave = async (userId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/reporting-manager-for-leave`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const isSoleProjectManager = async (userId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/sole-project-manager`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserLeaves = async (
  userId,
  filterData,
  isUpdatedByAdmin,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application?${
        filterData.startDate ? 'startDate=' + filterData.startDate + '&' : ''
      }${filterData.endDate ? 'endDate=' + filterData.endDate + '&' : ''}${
        filterData.status ? 'status=' + filterData.status + '&' : ''
      }${filterData.leaveId ? 'leaveId=' + filterData.leaveId + '&' : ''}${
        isUpdatedByAdmin ? 'isUpdatedByAdmin=' + isUpdatedByAdmin + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getLeaveTypeForUser = async (year) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/leave-type?year=${year}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const deleteUserTasks = async (userId, taskId) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${userId}/tasks/${taskId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getEmployeesOfManager = async (userId) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/manager/${userId}/employee`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    console.log('error= ', error);
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getLeavesRequest = async (
  userId,
  filterData,
  isUpdatedByAdmin,
  pageSize,
  pageNumber,
  multiDayOnly,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application/manager?${
        filterData.startDate ? 'startDate=' + filterData.startDate + '&' : ''
      }${filterData.endDate ? 'endDate=' + filterData.endDate + '&' : ''}${
        filterData.employeeId ? 'applierId=' + filterData.employeeId + '&' : ''
      }${filterData.status ? 'status=' + filterData.status + '&' : ''}${
        filterData.leaveId ? 'leaveId=' + filterData.leaveId + '&' : ''
      }${isUpdatedByAdmin ? 'isUpdatedByAdmin=' + isUpdatedByAdmin + '&' : ''}${
        filterData.projectId ? 'projectId=' + filterData.projectId + '&' : ''
      }${
        multiDayOnly !== undefined && multiDayOnly !== null
          ? 'multiDayOnly=' + multiDayOnly + '&'
          : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber !== undefined && pageNumber >= 0
          ? 'pageNumber=' + pageNumber
          : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    console.log('error= ', error);
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getWfhRequest = async (
  userId,
  filterData,
  isUpdatedByAdmin,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application/manager?type=WFH&reportingManagerFallback=false&${
        filterData.startDate ? 'startDate=' + filterData.startDate + '&' : ''
      }${filterData.endDate ? 'endDate=' + filterData.endDate + '&' : ''}${
        filterData.status ? 'status=' + filterData.status + '&' : ''
      }${
        filterData.employeeId ? 'applierId=' + filterData.employeeId + '&' : ''
      }${isUpdatedByAdmin ? 'isUpdatedByAdmin=' + isUpdatedByAdmin + '&' : ''}${
        filterData.projectId ? 'projectId=' + filterData.projectId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber !== undefined && pageNumber >= 0
          ? 'pageNumber=' + pageNumber
          : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response);
  }
};

/**
 * Senior Manager inbox: WFH requests routed here because the employee is the
 * sole active manager on their project (so there is no peer project manager
 * to approve them). Disjoint from the regular manager WFH tab via
 * reportingManagerFallback=true.
 */
export const getSeniorManagerWfhRequest = async (
  userId,
  filterData,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/application/manager?type=WFH&reportingManagerFallback=true&${
        filterData.startDate ? 'startDate=' + filterData.startDate + '&' : ''
      }${filterData.endDate ? 'endDate=' + filterData.endDate + '&' : ''}${
        filterData.status ? 'status=' + filterData.status + '&' : ''
      }${
        filterData.employeeId ? 'applierId=' + filterData.employeeId + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber !== undefined && pageNumber >= 0
          ? 'pageNumber=' + pageNumber
          : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response);
  }
};

export const getApplicationStatuses = async (applicationId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/applicationStatus/${applicationId}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const updateApplicationStatus = async (updatedApplication) => {
  try {
    const response = await _axios.put(
      `${WORKFLOW_PATH}/leaves/application/updateProcess`,
      updatedApplication,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getManagerProjects = async (
  managerId,
  projectName,
  pageSize,
  pageNumber,
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${managerId}/manager/projects?${
        projectName ? 'projectName=' + projectName + '&' : ''
      }${pageSize ? 'pageSize=' + pageSize + '&' : ''}${
        pageNumber >= 0 ? 'pageNumber=' + pageNumber : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getUserLeavesSummary = async (userId, tenantId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/leavesSummary`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserLeavesSummaryByYear = async (userId, year) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/leaves/${userId}/leavesSummary`,
      {
        params: {
          year: year,
        },
      },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserWfhSummary = async (userId, month, year, tenantId) => {
  try {
    const response = await _axios.get(
      `${WORKFLOW_PATH}/wfh/${userId}/tenant/${tenantId}/wfhSummary?month=${month}&year=${year}`,
    );
    console.log(
      `${WORKFLOW_PATH}/wfh/${userId}/tenant/${tenantId}/wfhSummary?month=${month}&year=${year}`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getEmployeesOnLeave = async (userId) => {
  try {
    const response = await _axios.get(`${PROJECT_PATH}/users/employeesOnLeave`);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getProjectsDurationSummary = async (
  userId,
  startDate,
  endDate,
  type,
  projectName,
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/${userId}/projectsDurationSummary?${
        startDate ? 'startDate=' + startDate + '&' : ''
      }${endDate ? 'endDate=' + endDate + '&' : ''}${
        type ? 'type=' + type + '&' : ''
      }${
        projectName && projectName != 'all'
          ? 'projectName=' + projectName + '&'
          : ''
      }`,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

export const getAllEmployees = async (
  tenantId,
  pageSize,
  pageNo,

  // eName,
  // status,
  // orgEmail,
  // searchString
) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/employees?${tenantId ? 'tenantId=' + tenantId : ''}?${
        pageSize ? '&pageSize=' + pageSize : ''
      }${pageNo >= 0 ? '&pageNumber=' + pageNo : ''}`,
    );

    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};

export const getUserPhoto = async (photoPath) => {
  try {
    const response = await _axios.get(
      `${PROJECT_PATH}/users/photoPath?${photoPath ? 'photoPath=' + photoPath : ''}`,
    );
    return response;
  } catch (error) {
    console.log('Error fetching photoUrl', error);
  }
};

export const updateUserPhoto = async (employee, uploadedPhoto) => {
  try {
    const formData = new FormData();
    formData.append('employeeId', employee.id);
    formData.append('emailId', employee.emailId);
    formData.append('file', uploadedPhoto);
    const response = await _axios.put(
      `${PROJECT_PATH}/users/updatePhoto`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error?.response?.data);
  }
};
